<template>
  <Layout footer>
    <div class="app-container text-base">
      <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
        <span class="mr-1">当前位置：</span>
        <NBreadcrumb>
          <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
          <NBreadcrumbItem>大数据分析</NBreadcrumbItem>
        </NBreadcrumb>
      </div>
      <img class="carousel-img" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/banner10.png" />
      <div class="flex items-center my-4 zhu_yi">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/news.png" alt="" />
        <span class="mx-2 text-base font-bold">注意事项：</span>
        <span style="color: #f70707">
          大数据平台属于业务主管部门数据展示仓功能，学员账号提供个人学习报告等学习依据。
        </span>
      </div>
      <div class="mt-14 pl-6" style="text-indent: 2em">
        大数据分析平台,实时数据分析。利用大数据技术实现数据分析+智能决策，实时分析培训数据，为学员提供学习
        分析，为培训单位提供培训分析，为管理部门提供辅助决策。
      </div>
      <img class="w-10/12 mx-auto mt-14"
        src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content10-1.png" />
      <div class="relative text-white">
        <img class="w-full mx-auto mt-14"
          src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content10-2.png" />
        <p class="absolute leading-7" style="width: 440px; bottom: 125px; left: 50%; margin-left: -220px">
          平台根据培训情况生成数据报表，供管理单位和培训单位使用,
          方便整体掌握培训情况，及时调整培训计划。
        </p>
      </div>
    </div>
  </Layout>
</template>

<script setup>
import Layout from '@/components/Layout';
import { useRouter } from 'vue-router';

const router = useRouter();
function gotoHome () {
  router.push('/');
}
</script>

<style lang="scss" scoped>
.carousel-img {
  display: block;
  width: 100%;
  height: 410px;
  object-fit: cover;
}

.zhu_yi {
  border: 1px dashed #f39a1d;
  height: 60px;
  font-size: 20px;
}
</style>
